<template>
  <div class="content-mail-cdg">
    <div
      v-if="loader == true"
      class="loading-custom-template-block-envoi-email-oblige"
    >
      <Half-circle-spinner
        :animation-duration="1000"
        :size="50"
        :color="'#704ad1'"
        class="loeder"
      />
    </div>

    <div>
      <v-switch
        v-if="dataToUse != null"
        v-model="dataToUse.vendeur_client"
        class="check-style-custom-obligee-mail"
        color="#704ad1"
      >
        <template v-slot:label>
          <span class="title-check-obligee-mail"> {{ label }}</span>
        </template>
      </v-switch>
      <div v-if="dataToUse == null" class="check-style-custom-obligee-mail">
        <span class="title-check-obligee-mail">{{ label }}</span>
      </div>
      <div v-if="error != null" class="error-message text-center ">
        <span>{{ error }}</span>
      </div>
      <template v-if="error == null && loader == false && dataToUse != null">
        <b-row class="row">
          <b-col col xs="6" sm="12" md="6">
            <!-- Title  -->
            <v-text-field
              class="input-email"
              v-model="dataToUse.title"
              outlined
              label="Titre"
              hide-details
              clearable
              color="#704ad1"
            ></v-text-field>
          </b-col>

          <b-col col xs="6" sm="12" md="6">
            <!--  Mail  -->
            <v-text-field
              class="input-email"
              v-model="dataToUse.mail"
              type="email"
              label="Email"
              outlined
              hide-details
              clearable
              color="#704ad1"
            ></v-text-field>
          </b-col>
        </b-row>
        <b-row cols="2">
          <b-col>
            <label class="input-modal-champ" v-if="dataToUse"
              >Extra mail
            </label>
          </b-col>
          <b-col>
            <v-btn
              text
              small
              @click="handleModalAddExtraMail()"
              class="button-add-mail"
              ><font-awesome-icon icon="plus"/></v-btn
          ></b-col>
        </b-row>

        <b-row class="row mb-2">
          <b-col col xs="12" sm="12" md="12">
            <!-- Extra mail  -->
            <v-select
              placeholder="Séléctionner"
              :items="dataToUse.extra_mails"
              v-model="dataToUse.extra_mails_list"
              outlined
              required
              multiple
              no-data-text="Aucun option trouvé"
              :persistent-placeholder="true"
              :rules="[v => !!v || 'extra email est obligatoire']"
              class="msg-error"
              validate-on-blur
              :menu-props="{ bottom: true, offsetY: true }"
              color="#704ad1"
              item-color="#704ad1"
              chips
              item-text="email"
              item-value="id"
              label="Extra Mails"
              return-object
              :deletable-chips="true"
              :small-chips="true"
              :clearable="true"
            >
            </v-select>
          </b-col>
        </b-row>
        <b-row class="row">
          <!-- Body -->
          <b-col col xs="12" sm="12" md="12">
            <editor
              v-model="dataToUse.html"
              :init="computedDataTinymce.init"
              api-key="fkvny27pjoyigjbydpscwei8n0785pudavymzl4qemdm7pzg"
            ></editor>
          </b-col> </b-row
      ></template>
    </div>
    <v-dialog
      v-model="ModalAddExtraMail"
      max-width="600px"
      scrollable
      hide-overlay
      persistent
      :retain-focus="false"
      :eager="true"
    >
      <v-card>
        <v-card-title class="text-h6 title-modal">
          <v-label class="label-header">Ajouter un Extra Mail</v-label>
          <v-btn
            class="btn-close-header"
            icon
            @click.prevent.stop="hideModalAddExtraMail()"
            title="Fermer"
            color="#704ad1"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="line-hr-header"></v-divider>
        <v-card-text class="mt-3">
          <v-text-field
            class="mt-2 msg-error"
            label="Extra Mail *"
            v-model="email"
            :rules="[v => !!v || 'email obligatoire']"
            validate-on-blur
            outlined
            required
            clearable
            hide-details
            :persistent-placeholder="true"
            color="#704ad1"
          ></v-text-field>
        </v-card-text>
        <div class="messageError">
          <div v-if="errors">
            <ul v-if="Array.isArray(errors)">
              <li
                class="message-error"
                v-for="(e, index) in errors"
                :key="'error' + index"
              >
                {{ e }}
              </li>
            </ul>
            <div v-else class="message-error">{{ errors }}</div>
          </div>
        </div>
        <v-divider class="line-hr-footer"></v-divider>
        <v-card-actions class="body-card center-text  mt-2">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="#704ad1"
            :disabled="loading"
            :class="{ loader: loading }"
            @click.prevent.stop="createExtraMail()"
          >
            Valider
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<!-- <script src="//cdn.tinymce.com/4/tinymce.min.js"></script> -->
<script>
import Editor from '@tinymce/tinymce-vue';

import { mapActions, mapGetters } from 'vuex';
export default {
  data() {
    return {
      email: null,
      errors: null,
      loading: false,
      ModalAddExtraMail: false
    };
  },
  props: {
    label: { required: true },
    loader: { required: true },
    dataToUse: { required: true },
    error: { required: true }
  },
  methods: {
    ...mapActions(['setLisImage', 'addExtraMail']),
    handleModalAddExtraMail() {
      this.ModalAddExtraMail = true;
    },
    hideModalAddExtraMail() {
      this.ModalAddExtraMail = false;
      this.email = null;
      this.errors = null;
    },
    async createExtraMail() {
      this.errors = null;
      this.loading = true;
      let extraMail = new FormData();
      extraMail.append('filiale_id', this.dataToUse.filiale);
      extraMail.append('email', this.email);
      const response = await this.addExtraMail(extraMail);
      if (response.success == true) {
        this.loading = false;
        this.dataToUse.extra_mails_list.push(response.result);
        this.dataToUse.extra_mails.push(response.result);
        this.hideModalAddExtraMail();
      } else {
        this.loading = false;
        this.errors = response.result;
      }
    }
  },
  computed: {
    ...mapGetters(['getImageTemplateList']),
    computedImageList() {
      return this.getImageTemplateList.map(item => {
        return { title: item.title, value: item.url };
      });
    },
    computedDataTinymce() {
      return {
        init: {
          selector: '#editor',
          init_instance_callback: function(editor) {
            var freeTiny = document.querySelector(
              '.tox-notifications-container'
            );
            if (freeTiny) {
              freeTiny.style.display = 'none';
            }
          },
          height: 450,
          fullpage_default_doctype: '<!DOCTYPE html>',
          fullpage_default_encoding: 'UTF-8',
          plugins: [
            'advlist autolink lists link image  print preview hr',
            'searchreplace visualblocks code ',
            'insertdatetime  table paste imagetools charmap'
          ],
          fontsize_formats: '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt 48pt 50pt',

          toolbar_mode: 'floating',
          powerpaste_allow_local_images: true,
          language: 'fr_FR',
          toolbar:
            ' undo redo | bold italic underline | alignleft aligncenter alignright alignjustify |  link image |' +
            ' bullist  numlist outdent indent  |  forecolor backcolor  |' +
            '   print preview  fullpage |' +
            ' hr charmap',
          menubar: 'favs file edit view insert format   ',
          menu: {
            format: {
              title: 'Format',
              items:
                'bold italic underline strikethrough superscript subscript codeformat | formats blockformats fontformats fontsizes align | forecolor backcolor | removeformat '
            }
          },
          contextmenu: false,
          removed_menuitems: 'paste pastetext',
          block_formats: 'box=alert-box; badge=badge; footer=footer',
          formats: {
            'alert-box': {
              block: 'div',
              styles: {
                'background-color': '#f4f5f9',
                padding: '20px'
              }
            },
            footer: {
              block: 'div',
              styles: {
                'background-color': ' #c7c7c7',
                padding: '20px'
              }
            },
            badge: {
              title: 'Badge',
              inline: 'span',
              styles: {
                display: 'inline-block',
                border: '.1rem solid transparent',
                'border-radius': '50px',
                padding: '1rem',
                'margin-top': '0px',
                'margin-bottom': '1rem',
                color: '#2276d2',
                'box-shadow': '2px 3px #d6d7da',
                'background-color': '#008cd6',
                color: 'white'
              }
            }
          },
          /* enable title field in the Image dialog*/
          image_title: true,
          /* enable automatic uploads of images represented by blob or data URIs*/
          automatic_uploads: true,
          image_list: success => success(this.computedImageList),
          file_picker_types: 'image',
          images_upload_handler: async (blobInfo, success, failure) => {
            let param = new FormData();
            param.append('image', blobInfo.blob());
            this.setLisImage(param)
              .then(response => {
                success(response.data.data.url);
              })
              .catch(error => {
                failure('HTTP Error: ' + error.message);
              });
          }
        }
      };
    }
  },
  components: {
    Editor
  }
};
</script>

<style lang="scss" scoped>
.button-add-mail {
  font-size: 10px;
  float: right;
  background: #b4a1e663;
  width: 25px !important;
  min-width: 25px !important;
  border: 1px solid #704ad1;
  color: #704ad1;
  height: 25px;
}
.message-error {
  color: red;
  list-style: none;
}
.title-check-obligee-mail {
  color: #704ad1;
  text-align: center;
  font-weight: 600;
  font-size: 18px;
  //   margin-bottom: 10px;
}
.label-item-custom-mail-obligee {
  font-size: 9px;
}
.input-modal-champ {
  color: #704ad1;
  float: left;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 0px !important;
}
.loading-custom-template-block-envoi-email-oblige {
  position: absolute;
  height: 100%;
  top: 0px;
  right: 0px;
  left: 0px;
  bottom: 0px;
  width: 100%;
  padding-top: 25% !important;
  padding-left: 45% !important;
  background-color: #ffffff87;
  z-index: 10;
}
</style>
<style lang="scss">
.content-mail-cdg {
  .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)
    > .v-input__control
    > .v-input__slot
    fieldset {
    color: rgb(224 224 224 / 92%) !important;
  }
}
.check-style-custom-obligee-mail {
  text-align-last: center;
  margin-bottom: 20px;
  display: inline-block;
  .custom-control-input:checked ~ .custom-control-label::before {
    color: #fff;
    border-color: #704ad1;
    background-color: #704ad1;
  }
}
</style>
